import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { FeedbackTypeOption } from 'src/app/clinical-feedback/clinical-feedback.model';
import { Region, SeriousIncidentType } from '@app/api-module/control-centre-api-client';

@Component({
    selector: 'app-advised-serious-incident-form',
    templateUrl: './advised-serious-incident-form.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class AdvisedSeriousIncidentFormComponent implements OnInit, OnDestroy {
    @Input() accessionNumber!: string;
    @Input() region?: Region;
    formControlName = 'advisedSeriousIncident';
    formGroup!: UntypedFormGroup;
    private readonly subscriptions = new Subscription();

    showForm = false;
    showConfirmedSeriousIncident = false;
    showDutyOfCandourForm = false;
    showRegulatoryInvestigationsForm = false;
    showOtherForm = false;

    constructor(private readonly fb: UntypedFormBuilder, public parent: FormGroupDirective) {}

    ngOnInit(): void {
        this.formGroup = this.fb.group({});
        this.parent.form.addControl(this.formControlName, this.formGroup);
        this.formGroup.disable();
        this.handleFormValueChanges();
    }

    get feedbackForm() {
        return (this.parent.form.get('feedback') as UntypedFormGroup).controls;
    }

    handleFormValueChanges() {
        this.subscriptions.add(
            combineLatest([
                this.feedbackForm['feedbackType'].valueChanges,
                this.feedbackForm['seriousIncidentType'].valueChanges
            ]).subscribe(([feedbackTypeValue, seriousIncidentTypeValue]) => {
                if (feedbackTypeValue === FeedbackTypeOption.AdvisedSeriousIncident && seriousIncidentTypeValue) {
                    this.showForm = true;
                    this.formGroup.enable();
                } else {
                    this.showForm = false;
                    this.formGroup.disable();
                }
                this.showConfirmedSeriousIncident =
                    this.showForm &&
                    (seriousIncidentTypeValue === SeriousIncidentType.ConfirmedSeriousIncident ||
                        seriousIncidentTypeValue === SeriousIncidentType.AimsIms);
                this.showDutyOfCandourForm = this.showForm && seriousIncidentTypeValue === SeriousIncidentType.DutyOfCandour;
                this.showRegulatoryInvestigationsForm =
                    this.showForm && seriousIncidentTypeValue === SeriousIncidentType.RegulatoryInvestigations;
                // Disable other form rather than completely remove, in case it will need a restore in the future.
                this.showOtherForm = false;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
